import { startSyllableTool } from "./syllable-tool.js";
import { startTools } from "./start-tools.js";

/**
 * The bundle for the two converters that read syllables rather than
 * characters: pinyin in, and bopomofo in.
 *
 * One bundle for both, because they are the same tool read from either end and
 * `partials/tools/romanisation.html` is the same markup for both pages. A
 * visitor who tries the second after the first downloads nothing.
 *
 * It exports nothing, and that is the point — a module whose whole purpose is
 * a side effect should not also be something other modules import.
 */
startTools(
  document,
  new Map([
    ["pinyin", startSyllableTool],
    ["bopomofo", startSyllableTool],
  ]),
);
